export function deepCloneObject(data) {
  return JSON.parse(JSON.stringify(data));
}

export function deepCloneString(string) {
  return (" " + string).slice(1);
}
